import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Sidebar extends Vue {
    google: any;

    search = '';

    interval!: number;

    get searchUrl() {
        return `https://www.google.com/search?q=site:chromosome6.org ${this.search}`;
    }

    mounted() {
        this.checkTranslate();

        (window as any).twttr.widgets.load();
    }

    checkTranslate() {
        this.interval = window.setInterval(() => {
            if (google.translate.TranslateElement.InlineLayout) {
                this.addTranslate();

                window.clearInterval(this.interval);
            }
        }, 200);
    }

    addTranslate() {
        this.google = new google.translate.TranslateElement({
            pageLanguage: 'en',
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        }, 'google_translate_element');
    }

    stopTranslate() {
        if (this.google) {
            this.google.setEnabled(false);
        }
    }

}
